// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overlay_wrapper__L_wl4","overlay":"overlay_overlay__Tz5Bc","overlayActive":"overlay_overlayActive__vkgb1"};